/**
 * Included into the footer of pages.
 */

import * as variables from './variables';

import {onDocumentLoaded} from "@plaudit/frontend-apis";

import './lib/AnimationEasing';

import "./lib/AnalyticsSetup";

import DetectBrowser from './lib/DetectBrowser';
DetectBrowser.applyAttributes(document.documentElement);

import {addChosenLocaleUpdater} from "./lib/cookie-helpers";
import ViewportTracker from './lib/ViewportTracker';
ViewportTracker.init(variables);

import {videoModals} from "./component/VideoModal/VideoModal";
videoModals({
	// If you want a custom play button, uncomment this line
	// customPlayButton: require("./component/VideoModal/VideoModal.svg?string")
});


// ---------------------------------------------------------------------------------------------- //
// Masthead Video Play/Pause
// ---------------------------------------------------------------------------------------------- //
onDocumentLoaded(() => {
	for (const videoIcon of document.querySelectorAll(".videoIcon")) {
		const video = videoIcon.closest(".wp-block-video")?.querySelector<HTMLMediaElement>(".videoBg");
		if (!video) {
			continue;
		}
		const updateVideoIcon = () => {
			videoIcon.classList.toggle('icon--play', video.paused);
			videoIcon.classList.toggle('icon--pause', !video.paused);
			videoIcon.ariaLabel = video.paused ? "Play button" : "Pause button";
			videoIcon.ariaPressed = video.paused ? "false" : "true";
		}

		videoIcon.addEventListener('click', () => {
			if (video.paused) {
				video.play();
			} else {
				video.pause();
			}
		});

		video.addEventListener('pause', updateVideoIcon);
		video.addEventListener('play', updateVideoIcon);

		updateVideoIcon();
	}
});

// Blog listing page - checks for URL parameters to hide the featured blog.
document.addEventListener('DOMContentLoaded', () => {
    const blogTeaser = document.querySelector('.wp-block-plaudit-article.tease--blog') as HTMLElement;
    if (!blogTeaser) return;

    // Function to check visibility based on URL parameters
    const updateTeaserVisibility = () => {
        const urlParams = new URLSearchParams(window.location.search);
        const pageParam = urlParams.get('query-4-page');
        blogTeaser.style.display = (pageParam && parseInt(pageParam) > 1) ? 'none' : '';
    };

    // Initial check
    updateTeaserVisibility();

    // Listen for URL changes (like when filters are applied)
    const observer = new MutationObserver(() => {
        updateTeaserVisibility();
    });

    // Watch for changes in the URL
    observer.observe(document.querySelector('body')!, {
        childList: true,
        subtree: true
    });
});

onDocumentLoaded(() => {
	for (const clickable of document.querySelectorAll("a:has(> span > span.wpml-ls-native)")) {
		addChosenLocaleUpdater(clickable);
	}
})

for (const form of document.querySelectorAll<HTMLFormElement>("form.region-form")) {
	form.querySelector<HTMLSelectElement>("select[name='region']")?.addEventListener('change', () => form.requestSubmit());
}


// ---------------------------------------------------------------------------------------------- //
// Animations
//
// SEE EXAMPLE BELOW:
//
// import InViewObserver from './lib/InViewObserver';
// InViewObserver.createInstance([
// 	{
// 		observeSelector: '.pageContent > .wp-block-group, .callToAction, .site-footer__content',
// 		minimum: 20,
// 		minimumUnit: "px"
// 	},
// 	{
// 		observeSelector: '.decorativeShape__canvas, .site-footer__donutCanvas',
// 		minimum: 20,
// 		minimumUnit: "px"
// 	}
// ]);
// ---------------------------------------------------------------------------------------------- //
